export default "__VITE_ASSET__CfSfZJe4__"